import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000FA0',
    },
    secondary: {
      main: '#F3C300',
    },
    success: {
      main: '#64BC47',
    },
    'Feedback/Info': '#3B70BF',
    'Feedback/Sucess': '#64BC47',
    'Black-White/Black': '#000748',
    'Feedback/Erro': '#FF5353',
    'Functions/Text': '#8898AA',

    'Brand/Solid/2': '#26A9E0',
    'Brand/Solid/Primary': '#000F9F',
    'Ambient/Base/Black': '#000748',
    'Ambient/Base/White': '#F5F6FB',
    'Ambient/Deep/Black': '#000000',
    'Ambient/Deep/White': '#FFFFFF',
    'Ambient/Deep/Green': '#F5FBF7',
    'Ambient/Grayscale/Gray-300': '#7C7C7C',
    'Ambient/Grayscale/Gray-200': '#A5A5A5',
    'Ambient/Grayscale/Gray-100': '#D5D5D5',
    'Ambient/Grayscale/Gray-50': '#F4F4F4',
    'Ambient/Neutrals/Table-Head-BG': '#8898AA',
    'Ambient/Neutrals/Line-Color': '#D1DAF8',
    'Interaction/Feedback/Success': '#64BC47',
    'Interaction/Feedback/Info': '#3B70BF',
    'Interaction/Feedback/Erro': '#FF5353',
    'Interaction/Feedback/Alert': '#DAB701',
  },
  typography: {
    'Headlines/XLarge': {
      fontFamily: 'Open Sans',
      fontWeight: 600,
      fontSize: 24,
    },
    'Headlines/Large': {
      fontFamily: 'Open Sans',
      fontWeight: 700,
      fontSize: 16,
    },
    'Headlines/Medium': {
      fontFamily: 'Open Sans',
      fontWeight: 400,
      fontSize: 14,
    },
    'Headlines/Small': {
      fontFamily: 'Open Sans',
      fontWeight: 600,
      fontSize: 12,
    },
    'Label/Medium': {
      fontFamily: 'Inter',
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: 14,
    },
    'Label/Small': {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: 11,
    },
    'Paragraph/Medium': {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: 14,
    },
  },
});

export { theme };
export type ColorVariants = keyof typeof theme.palette;
